import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PricingService} from '../../service/pricing.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {

  SEARCH = 'SEARCH';
  RESULT = 'RESULT';
  EMAIL_RATE_SEND = 'EMAIL_RATE_SEND';
  // tslint:disable-next-line:variable-name
  _mode: string;

  @Input() set mode(value) {
    if (value !== this._mode) {
      this.result = null;
    }
    this._mode = value;
  }

  get mode() {
    return this._mode;
  }

  @Input() graphColor = '5, 121, 162';
  @Input() refId = '65e78384ce8ad00001f21a2d';

  @Input() loanPurpose: string = null;
  @Input() propertyUse: string = null;
  @Input() propertyType: string = null;
  @Input() preferredAmortization: string = null;
  @Input() fico: number = null;
  @Input() zip: string = null;
  @Input() homeValue: number = null;
  @Input() amount: number = null;
  @Input() lockDays: number = null;
  @Input() secondLoanOption: boolean = null;
  @Input() escrowWaiver: boolean = null;
  @Input() secondLoanAmount: number = null;
  @Input() showVA: boolean = null;
  @Input() unit: number = null;
  @Input() computePropertyTax: boolean = null;

  @Input() searchLabel = 'See My Options';

  @Output() modeOut = new EventEmitter();


  miniPricerRef: any;
  search = {
    id: '58bf0bb84cedfd000136eeea',
    fico: 700,
    showDisqualifiedbyRules: false,
    loanPurpose: 'Purchase',
    zip: '91106',
    state: 'CA',
    preferredAmortization: 'Fixed',
    city: 'Pasadena',
    amount: 400000,
    secondLoanAmount: 0,
    downPercent: 20,
    homeValue: 500000,
    ltv: 0.8,
    propertyUse: 'PrimaryResidence',
    propertyType: 'SingleFamily',
    loanCriterias: [
      {
        id: '58bf0bbd4cedfd000136f14c',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'First',
        limit: 3,
        name: '30 Year Fixed',
        mortgageType: 'Conventional',
        loanType: 'Fixed',
        term: 30,
        varaiableLoanType: '_5_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      },
      {
        id: '58bf0bbe4cedfd000136f1e1',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'First',
        limit: 3,
        name: '15 Year Fixed',
        mortgageType: 'Conventional',
        loanType: 'Fixed',
        term: 15,
        varaiableLoanType: '_5_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      },
      {
        id: '5c7ee2c14cedfd0001a7d319',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'First',
        limit: 3,
        name: '7/1 ARM',
        mortgageType: 'Conventional',
        loanType: 'Variable',
        term: 30,
        varaiableLoanType: '_7_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      },
      {
        id: '5d7803e54cedfd00014f6f92',
        closingCostRange: {
          '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
          closestToPar: false
        },
        selectionType: 'FirstLast',
        name: '5/1 Arm',
        mortgageType: 'Conventional',
        loanType: 'Variable',
        term: 30,
        varaiableLoanType: '_5_1',
        showOnlyIfSecondLoan: false,
        showOnlyIfVASelected: false,
        showWhenEmpty: true,
        ltvRange: {
          '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
          null: true
        },
        noticeConf: {
          closingCostNotices: '',
          productDescription: '',
          disclosure: ''
        },
        limitRates: true,
        showAdjAsLenderCredit: true
      }
    ],
    escrowWaiver: false,
    lenderFeeWaiver: false,
    showVA: true,
    secondLoanOption: false,
    lockDays: 30,
    unit: 1,
    ownProperties: 0
  };

  contact = {
    propertyAddress: {
      state: '',
      street: '',
      streetCont: '',
      city: '',
      zip: '',

    },
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  };

  result: any = null;
  loading = false;


  constructor(protected pricingService: PricingService,
              protected http: HttpClient) {

  }

  ngOnInit(): void {
    this.loading = true;
    this.search = null;
    this.pricingService.getSearch(this.refId).toPromise()
      .then(ref => {
        this.miniPricerRef = ref;
        this.search = ref.miniPricerPref.search;
        this.search.preferredAmortization = 'Fixed';
        this.search.secondLoanAmount = 0;

        this.search.loanPurpose = this.loanPurpose === null ? this.search.loanPurpose : this.loanPurpose;
        this.search.propertyUse = this.propertyUse === null ? this.search.propertyUse : this.propertyUse;
        this.search.propertyType = this.propertyType === null ? this.search.propertyType : this.propertyType;
        this.search.preferredAmortization = this.preferredAmortization === null ?
          this.search.preferredAmortization : this.preferredAmortization;
        this.search.fico = this.fico === null ? this.search.fico : this.fico;
        this.search.zip = this.zip === null ? this.search.zip : this.zip;
        this.search.homeValue = this.homeValue === null ? this.search.homeValue : this.homeValue;
        this.search.amount = this.amount === null ? this.search.amount : this.amount;
        this.search.lockDays = this.lockDays === null ? this.search.lockDays : this.lockDays;
        this.search.secondLoanOption = this.secondLoanOption === null ? this.search.secondLoanOption : this.secondLoanOption;
        this.search.escrowWaiver = this.escrowWaiver === null ? this.search.escrowWaiver : this.escrowWaiver;
        this.search.secondLoanAmount = this.secondLoanAmount === null ? this.search.secondLoanAmount : this.secondLoanAmount;
        this.search.showVA = this.showVA === null ? this.search.showVA : this.showVA;
        this.search.unit = this.unit === null ? this.search.unit : this.unit;

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        console.error(err);
      });
  }

  triggerSearch($event) {

    this.modeOut.emit(this.RESULT);

    const searchLoanPurpose = this.miniPricerRef.miniPricerPref.search.loanPurpose
    if ('miniPricerPref' in this.miniPricerRef) {
      if ('originalSearch' in this.miniPricerRef.miniPricerPref && 'loanPurposeCriteria' in this.miniPricerRef.miniPricerPref.originalSearch) {
        if (this.miniPricerRef.miniPricerPref.originalSearch.loanPurposeCriteria.length > 0){
          if (this.miniPricerRef.miniPricerPref.originalSearch.loanPurposeCriteria !== searchLoanPurpose) {
            this.miniPricerRef.miniPricerPref.originalSearch.loanPurposeCriteria = [searchLoanPurpose]
          }
          this.miniPricerRef.miniPricerPref.search.loanPurposeCriteria = [searchLoanPurpose]
        } else {
          this.miniPricerRef.miniPricerPref.search.loanPurposeCriteria = [searchLoanPurpose]
        }
      } else {
        this.miniPricerRef.miniPricerPref.search.loanPurposeCriteria = [searchLoanPurpose]
      }
    }

    this.loading = true;
    this.pricingService.search(this.miniPricerRef).toPromise()
      .then(data => {
        this.result = data;

        this.loading = false;
      })
      .catch(err => {
        console.error(err);
        this.loading = false;
      });
  }

  emailRatesNow($event) {
    this.loading = true;
    this.pricingService.sendEmail($event).toPromise()
      .then(data => {
        this.result = data;
        this.modeOut.emit(this.EMAIL_RATE_SEND);
        this.loading = false;
      })
      .catch(err => {
        console.error(err);
        this.loading = false;
      });
  }

  backToSearch() {
    this.modeOut.emit(this.SEARCH);
  }
}
